/**
 * High Grade Expert Reviews — Swiper, scoped to each section.
 * Slider bleeds to the viewport on the right for next-card peek.
 * Left overflow stays visible in section padding. Last slide keeps a right gutter
 * so it lines up with the header, not the screen edge.
 */
(function () {
  'use strict';

  var instances = [];

  function endGutter(section, carousel) {
    var inner = section.querySelector('.high-grade-expert-reviews__inner');
    if (!inner || !carousel) return 0;
    var extra = carousel.getBoundingClientRect().right - inner.getBoundingClientRect().right;
    return extra > 1 ? Math.round(extra) : 0;
  }

  function bindSection(section) {
    if (!section || section.dataset.hgerBound === 'true') return;

    var carousel = section.querySelector('.high-grade-expert-reviews__slider');
    var SwiperCtor = window.Swiper;
    if (!carousel || !SwiperCtor) return;

    section.dataset.hgerBound = 'true';

    var swiper = new SwiperCtor(carousel, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      speed: 500,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      slidesOffsetAfter: endGutter(section, carousel),
      navigation: {
        nextEl: section.querySelector('.high-grade-expert-reviews__arrow--next'),
        prevEl: section.querySelector('.high-grade-expert-reviews__arrow--prev')
      },
      breakpoints: {
        990: {
          slidesPerView: 1.8,
          spaceBetween: 20
        },
        1450: {
          slidesPerView: 2,
          spaceBetween: 20
        }
      },
      on: {
        resize: function () {
          this.params.slidesOffsetAfter = endGutter(section, carousel);
          this.update();
        }
      }
    });

    requestAnimationFrame(function () {
      if (swiper.destroyed) return;
      swiper.params.slidesOffsetAfter = endGutter(section, carousel);
      swiper.update();
    });

    instances.push({
      section: section,
      destroy: function () {
        if (swiper && !swiper.destroyed) swiper.destroy(true, true);
        section.dataset.hgerBound = 'false';
      }
    });
  }

  function destroySection(section) {
    instances = instances.filter(function (item) {
      if (item.section === section) {
        item.destroy();
        return false;
      }
      return true;
    });
  }

  function init() {
    document.querySelectorAll('.high-grade-expert-reviews').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.classList.contains('high-grade-expert-reviews')
      ? event.target
      : event.target.querySelector('.high-grade-expert-reviews');
    if (section) bindSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.classList.contains('high-grade-expert-reviews')
      ? event.target
      : event.target.querySelector('.high-grade-expert-reviews');
    if (section) destroySection(section);
  });
})();
